export default __webpack_public_path__ + "static/media/Template.0cfa4748.png";